/**
 * Utility to allow exhaustive checks in switch statements
 * at typechecking time
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function assertUnreachable(x: never): never {
  throw new Error(`Missing case for ${x})}`);
}
